import React from 'react';

import './index.css';


class CompetencyGraph extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            segments: [{
                'segmentNo': '0',
                'segmentName': ''
            }, {
                'segmentNo': '2.0',
                'segmentName': ''
            }, {
                'segmentNo': '4.0',
                'segmentName': ''
            }, {
                'segmentNo': '6.0',
                'segmentName': ''
            }, {
                'segmentNo': '8.0',
                'segmentName': ''
            }, {
                'segmentNo': '10.0',
                'segmentName': ''
            }]
        };
    }

    render() {
        return (
            <React.Fragment>
                <div className="d-flex flex-row col-12 mx-1">
                    <div className="col-5 px-2  align-items-center text-left ">
                    </div>
                    <div className="col-7 pl-0  d-flex flex-row">
                        {
                            this.state.segments.map(
                                (data, i) => {
                                    return <div key={i} style={{ border: 'none' }} className="col-2 px-0 text-left ">{data.segmentNo}</div>
                                }
                            )
                        }
                    </div>
                </div>
                <div className="d-flex flex-row col-12 mx-1" >
                    <div className="col-5 border px-3 py-1 font-weight-bold text-left text-left text-white" style={{ backgroundImage: this.props.tableHeadingColor }}>
                        {
                            this.props.textSmall === true ? <small className="font-weight-bold mb-0">
                                Competency
                            </small> : <p className="font-weight-bold mb-0">
                                    Competency
                                </p>
                        }

                    </div>
                    <div className="col-7 border px-0  d-flex flex-row" style={{ backgroundImage: this.props.continuesHeading ? this.props.continuesHeading : this.props.tableHeadingColor }}>
                        {
                            this.state.segments.map(
                                (data, i) => {
                                    return <div key={i} style={{ border: 'none', borderRight: '1px solid white' }} className="col-2 px-0 text-left "></div>
                                }
                            )
                        }
                    </div>
                </div>
                <div className="d-flex flex-column">
                    {
                        this.props.data.map((val, key) => {
                            return (
                                <div key={key} className="d-flex flex-row col-12 mx-1 ">
                                    <div id={`Target${key}`} onClick={() => this.props.onActionInvoked(key, val)} style={{ height: this.props.height ? this.props.height : 70, backgroundColor: ``, color: `${(this.props.Tooltip === true && key === this.props.selected_route_parameter) ? this.props.highlightTextColor : 'black'}` }} className={`d-flex flex-row justify-content-between align-items-center col-5 border ${this.props.padding ? this.props.padding : 'py-2'} px-3  text-left cursor-pointer focus_background_yellow`}>
                                        {
                                            this.props.textSmall === true ? <small className="font-weight-bold mb-0">
                                                {val.title}
                                            </small> : <p className="font-weight-bold mb-0" style={{fontSize: this.props.fontSize ? this.props.fontSize : 16}}>
                                                    {val.title}
                                                </p>
                                        }

                                        <i style={{ color: `${(this.props.Tooltip === true && key === this.props.selected_route_parameter) ? this.props.highlightTextColor : 'black'}` }} className="fas fa-caret-right text-right"></i>
                                    </div>
                                    <div className={`col-7 border ${this.props.padding ? this.props.padding : 'py-3'} px-0`} style={{ display: 'flex', flexDirection: 'column', }}>
                                        <div style={{ display: 'flex', flex: 10, flexDirection: 'row', }}>
                                            <div style={{ flex: parseFloat(val.title_value), backgroundColor: this.props.barColor }}>
                                            </div>
                                            <div className="text-left px-1 align-items-center d-flex" style={{ flex: (11.8 - parseFloat(val.title_value)), fontSize: 14 }}>
                                                {parseFloat(val.title_value).toFixed(2)}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </React.Fragment>
        )
    }

}


export default CompetencyGraph



// WEBPACK FOOTER //
// ./src/_components/common/CompetencyGraph/index.js